export default function ProcessingSpeedsSection() {
  const speeds = [
    { days: "3 Business Days", price: "From $345", desc: "Most urgent — hand-courier, overnight FedEx return.", popular: false },
    { days: "4 Business Days", price: "From $295", desc: "Trip within 1–2 weeks.", popular: true },
    { days: "7 Business Days", price: "From $245", desc: "Trip within about 2 weeks.", popular: false },
    { days: "9 Business Days", price: "From $195", desc: "Trip 2–3 weeks out.", popular: false },
    { days: "3–5 Weeks", price: "Smart Saver", desc: "Trip 3+ weeks out. Most affordable.", popular: false },
  ];

  return (
    <section id="pricing" className="py-16 md:py-20 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          Processing Speeds &amp; Pricing
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12 text-base md:text-lg">
          Pick the tier that fits your travel date. All tiers include expert document review, courier submission, and overnight FedEx return.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {speeds.map((speed, i) => (
            <div key={i} className={`bg-white rounded-lg p-6 border relative ${speed.popular ? "border-[#4A7AB5] ring-2 ring-[#4A7AB5]/30" : "border-[#D0D7E2]"}`}>
              {speed.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#4A7AB5] text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                  Most Popular
                </div>
              )}
              <h3 className="font-bold text-lg text-[#1A365D] mb-1">{speed.days}</h3>
              <p className="text-2xl font-bold text-[#1A365D] mb-3">{speed.price}</p>
              <p className="text-xs text-gray-500 mb-5 leading-relaxed">{speed.desc}</p>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className="block w-full text-center bg-[#1A365D] hover:bg-[#0F2443] text-white text-sm font-bold py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>
          ))}
        </div>
        <p className="text-center text-gray-500 text-xs mt-6">
          Government fees are separate. FPC does not mark up government fees.
        </p>
      </div>
    </section>
  );
}